import styled from "styled-components";
import {
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	COLOR_LIGHT_GREEN_BACKGROUND,
} from "@website-builder/utilities-index";

export const RequestSyllabusWrapper = styled.div`
	display: flex;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: block;
	}
`;

export const TextWrapper = styled.div`
	padding: 105px 88px 85px 292px;
	width: 60%;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		width: 100%;
		padding: 85px 30px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 40px;
		text-align: center;
	}
`;

export const Heading = styled.div`
	font-size: 28px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-bottom: 30px;
`;

export const FormWrapper = styled.div`
	background-color: ${COLOR_LIGHT_GREEN_BACKGROUND};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 55px 30px;
	}
`;

export const RequestSyllabusForm = styled.div`
	width: 370px;
	padding: 100px 30px 0px 30px;
	.request-syllabus-form {
		display: block;
		margin: 0px;
		.formGroup {
			width: 100%;
			margin-top: 10px;
			margin-bottom: 10px;
			.submitButton {
				width: 100%;
			}
		}
		.successMessageWrapper {
			margin-top: 40px;
			display: block;
			.message {
				color: ${COLOR_TEXT_PRIMARY_B2C};
				display: block;
				text-align: center;
			}
		}
		div {
			img {
				display: none;
			}
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 0px;
		width: 100%;
	}
`;

export const FormHeading = styled.div`
	text-align: center;
	font-size: 20px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 2.25;
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;
